module.exports = __webpack_public_path__ + "img/icomoon.266f019f.svg";